module.exports = __webpack_public_path__ + "img/info.41e5698b.svg";